import { headingSm, textMd } from '@insify/design-system/typography';
import clsx from 'clsx';

import * as styles from './Typography.module.css';

import type { InsifyProps } from '@insify/ui';

type Density = 'condensed' | 'normal' | 'loose';

const densityClasses: Record<Density, string> = {
  normal: styles.normalMargins,
  condensed: styles.condensedMargins,
  loose: styles.looseMargins,
};

interface TypographyProps extends InsifyProps {
  children: React.ReactNode;
  density?: Density;
}

const Heading2: React.FC<TypographyProps> = ({ className, children, testId, density = 'normal' }) => (
  <h1 data-testid={testId} className={clsx(headingSm, densityClasses[density], className)}>
    {children}
  </h1>
);

const Paragraph: React.FC<TypographyProps> = ({ className, children, density = 'normal' }) => (
  <p className={clsx(textMd, densityClasses[density], className)}>{children}</p>
);

export { Heading2, Paragraph };
